import "./SingleProductTemplate.module.css"
import HeaderPrincipale from "@/reusable_sections/Header"
import SingleProductTemplateSection from "./sections/SingleProductTemplateSection"
import FooterInformativo from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <HeaderPrincipale />
      <SingleProductTemplateSection />
      <FooterInformativo />
    </div>
  )
}
